import SVPageMeta from '@apps/www/src/www/containers/SVPageMeta';
import SVWithUserPage, {
	type Props as SVWithUserPageProps,
} from '@apps/www/src/www/containers/SVWithUserPage';
import UserFollowersQuery from '@apps/www/src/www/queries/UserFollowersQuery';
import SVUsersList from '@pkgs/shared-client/components/SVUsersList';
import usePaginatedQuery from '@pkgs/shared-client/hooks/usePaginatedQuery';

const _SVUserFollowersPage = ({ user }: SVWithUserPageProps) => {
	const { items, loading, paginate, isLimited } = usePaginatedQuery(UserFollowersQuery, {
		variables: {
			userID: user._id,
		},
	});

	const meta = {
		title: `Followers – ${user.name}`,
	};

	return (
		<>
			<SVPageMeta {...meta} />
			<SVUsersList
				users={items || null}
				isLoading={loading}
				onPaginate={paginate}
				isLimited={isLimited}
			/>
		</>
	);
};

const SVUserFollowersPage = SVWithUserPage(_SVUserFollowersPage);

// @ts-ignore fix this
SVUserFollowersPage.withUserHeader = true;
// @ts-ignore fix this
SVUserFollowersPage.withUserSideMenu = true;

export default SVUserFollowersPage;
